<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="card modal-container" :style="{ 'max-width': maxWidth, 'overflow-y': overflowY }">
          <div class="modal-close" @click="$emit('close')" v-if="closable">
            <i class="icon-close"></i>
          </div>

          <div class="modal-header">
            <slot name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    maxWidth: {
      type: String,
      default: '400px'
    },
    closable: {
      type: Boolean,
      default: true
    },
    overflowY: {
      type: String,
      default: 'auto'
    }
  }
}
</script>

<style scoped></style>
